import React, { useRef, useEffect, useState } from "react";
import Print from "@arcgis/core/widgets/Print";

const PrintMapWidget = ({view,activeWidget,serviceUrl}) => {
  const [visible, setVisible] = useState(false);
  const printWidgetDiv = useRef(null);
  useEffect(() => {
    if (activeWidget === "PrintMapWidget") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  useEffect(() => {
    if (printWidgetDiv.current) {
      const printWidget = new Print({
        container: printWidgetDiv.current,
        view: view,
        printServiceUrl:
        serviceUrl//"https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
      });

      return () => {
        printWidget.destroy();
      };
    }
  }, []);
  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }
  return <div ref={printWidgetDiv} style={style}></div>;
};

export default PrintMapWidget;
